import actions from './actions';
import Cookies from 'js-cookie'

const { LOGIN_BEGIN, LOGIN_SUCCESS, LOGIN_ERR, LOGOUT_BEGIN, LOGOUT_SUCCESS, LOGOUT_ERR, LOGIN_RESPONSE } = actions;

const initState = {
  login: Cookies.get(process.env.REACT_APP_TOKEN_KEY, { domain: process.env.REACT_APP_DOMAIN }),
  loginResponse: {},
  loading: false,
  error: null,
};

/**
 *
 * @todo impure state mutation/explaination
 */
const AuthReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LOGIN_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case LOGIN_RESPONSE:
      // 在這裡做個身份的布爾值，用於後續權限的判斷
      let ndata = data;
      // ndata.userRole = [1, 3]; // test
      let auth = {
        isAdmin: true,
        isPerson: true,
        isPersonSeller: true,
        isBusinessSeller: true,
      }
      if (ndata.user?.role?.length) {
        if (!ndata.user.role.includes(4)) auth.isAdmin = false;
        if (!ndata.user.role.includes(2)) auth.isPersonSeller = false;
        if (!ndata.user.role.includes(3)) auth.isBusinessSeller = false;
      }
      ndata.auth = auth;
      return {
        ...state,
        login: ndata.jwt,
        loginResponse: ndata,
        loading: false,
      };
    case LOGIN_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case LOGOUT_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        login: data,
        loading: false,
      };
    case LOGOUT_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default AuthReducer;
